import React, {Fragment} from 'react';
import {ImageRatioOptions} from '../images';
import {CmsButtonProps, VerticalSpacer} from '..';
import {useBreakpointUp, AccentColorProps, useBreakpointDown} from 'epic-ue-theme';
import {CreatorFeedRow} from './CreatorFeedRow.molecule';
import {useActiveCreator} from './creatorfeed.hooks';
import {CreatorFeedDetailView} from './detail/CreatorFeedDetail.molecule';
import {CreatorFeedCard} from './card/CreatorFeedCard.molecule';
export interface CreatorsFeedItemProps {
    title?: string;
    caption?: string;
    description?: string;
    hoverText?: string;
    imageSrc?: string;
    avatarImageSrc?: string;
    ratio?: ImageRatioOptions;
    creatorBtn: CmsButtonProps;
    detailImages: string[];
}

export interface CreatorFeedProps {
    cards: CreatorsFeedItemProps[];
    browseLabel?: string;
}

type Chunks = CreatorsFeedItemProps[][];
const chunkSize = 3;
const getChunks = (cards: CreatorsFeedItemProps[]) => {
    const chunks: Chunks = [];
    for (let i = 0; i < cards.length; i += chunkSize) {
        const chunk = cards.slice(i, i + chunkSize);
        chunks.push(chunk);
    }

    return chunks;
};

export const CreatorFeed = ({
    cards = [],
    browseLabel,
    accentColor = 'sky'
}: CreatorFeedProps & AccentColorProps): JSX.Element => {
    const isMdUp = useBreakpointUp('md');
    const isSm = useBreakpointDown('sm');
    const {activeCreator} = useActiveCreator();
    const detailView = activeCreator !== '';
    let detailCard: CreatorsFeedItemProps | null = null;
    let detailCardIndex;

    if (detailView) {
        for (let i = 0; i < cards.length; i++) {
            const card = cards[i];
            if (cards[i].title === activeCreator) {
                detailCard = card;
                detailCardIndex = i;
                break;
            }
        }
    }

    const chunks = getChunks(cards);

    let content = chunks.map((chunk, i) => {
        const end = i % 2 === 0;
        return (
            <CreatorFeedRow
                key={`creator-feed-row-${i}`}
                cards={chunk}
                rowNum={i}
                alignItems={end ? 'flex-end' : 'flex-start'}
                accentColor={accentColor}
            />
        );
    });

    if (isSm) {
        content = cards.map((card, i) => {
            const rekt = i % 2 === 0;
            return (
                <Fragment key={card.title}>
                    <CreatorFeedCard
                        {...card}
                        ratio={rekt ? 'rect' : 'square'}
                        accentColor={accentColor}
                    />
                    <VerticalSpacer variant="custom" spacing={4} />
                </Fragment>
            );
        });
    }

    const square = detailCardIndex % 2 === 0;

    return (
        <div className="creator-feed">
            {detailView && detailCard ? (
                <CreatorFeedDetailView
                    cards={cards}
                    browseLabel={browseLabel}
                    {...detailCard}
                    accentColor={accentColor}
                    ratio={square ? 'square' : 'rect'}
                />
            ) : (
                ''
            )}
            {content}
            {isMdUp ? <VerticalSpacer variant="custom" spacing={3} /> : ''}
        </div>
    );
};
